<svelte:head>
    <link rel="stylesheet" href="/css/nail-style-blog/fonts.css">
</svelte:head>
<slot />